/**
 * Абсолютный URL файла. В проде хранилище S3 отдаёт https://…, локальное —
 * относительные /uploads/… (в dev их проксирует vite).
 */
export function mediaUrl(url: string | null | undefined): string | undefined {
  if (!url) return undefined;
  if (/^(https?:)?\/\//i.test(url) || url.startsWith('data:') || url.startsWith('blob:')) return url;
  const origin = (import.meta.env.VITE_API_URL?.trim() || '').replace(/\/+$/, '');
  return `${origin}${url.startsWith('/') ? '' : '/'}${url}`;
}
